import _ from 'lodash';
import moment from 'moment';
import Vue from 'vue';
import {AxiosResponse, AxiosError} from 'axios';
import {mapActions, mapGetters, mapState} from 'vuex';
import EventHub from '../../lib/eventHub';
import EnrollVirtualTrainingProgram from './enrollVirtualTrainingProgram.html';
import {EventConstant, ProfileModuleConstant, ProgramAlertConstant, RegularExpressionConstant, UrlModuleConstant} from '../../lib/constants';
import {coachService} from '../../lib/services/coachService';
import {planService} from '../../lib/services/planService';
import TimeZoneService from '../../lib/services/timeZoneService';
import MobileUtils from '../../lib/helpers/mobileUtils';
import EcCommon from '../../../types/ec/ecCommon';
import LtCommon from '../../../types/lt/ltCommon';

interface IComponentData {
	initializing: boolean;
	mobileUtils: LtCommon.IMobileUtils;
	coachService: EcCommon.ICoachService;
	planService: EcCommon.IPlanService;
	trainerizeToken: EcCommon.ITrainerizeToken;
	isUserEnrolledInProgram: boolean;
	programSettings: EcCommon.ISettings;
	userPrograms: EcCommon.IProgram[];
}

export default Vue.component('ecEnrollVirtualTrainingProgram', {
	template: EnrollVirtualTrainingProgram,
	data(): IComponentData {
		return {
			initializing: true,
			mobileUtils: {} as LtCommon.IMobileUtils,
			coachService,
			planService,
			trainerizeToken: {} as EcCommon.ITrainerizeToken,
			isUserEnrolledInProgram: false,
			programSettings: {} as EcCommon.ISettings,
			userPrograms: [],
		};
	},
	computed: {
		...mapGetters(ProfileModuleConstant.name, {getIsProfileValid: ProfileModuleConstant.getter.getIsValid}),
		...mapGetters(UrlModuleConstant.name, [UrlModuleConstant.getter.getGlobalPageDriverUrl]),
		...mapState(ProfileModuleConstant.name, [ProfileModuleConstant.state.profile]),
		errorMessage(): string {
			let errorMessage = '';
			if (this.planService.errorMessage) {
				errorMessage = this.planService.errorMessage;
			}

			if (this.coachService.errorMessage) {
				errorMessage = this.coachService.errorMessage;
			}

			return errorMessage;
		},
		loading(): boolean {
			return this.initializing || this.planService.loading;
		},
	},
	methods: {
		getProgramListForMember(): Promise<void> {
			return this.planService.getProgramListforMember(this.profile.partyId)
				.then((response: AxiosResponse<EcCommon.IProgram[]>) => {
					this.userPrograms = response.data;
					_.forEach(this.userPrograms, (p) => {
						p.startDate = TimeZoneService.convertToLocal(p.startDate, p.timeZone);
						p.endDate = TimeZoneService.convertToLocal(p.endDate, p.timeZone);
					});

					if (this.userPrograms.length) {
						const latestProgramThatUserIsEnrolledIn = _.maxBy(this.userPrograms, 'endDate');
						this.isUserEnrolledInProgram = latestProgramThatUserIsEnrolledIn?.sourceId === this.programSettings.sourceId;
					}
				});
		},
		goToVLT(): void {
			const appWindow = window.open('trainerize://', '_self');
			setTimeout(() => {
				if (appWindow) {
					window.location.assign(this.mobileUtils.storeUrl);
				}
			}, 1000);
		},
		getTrainerizeToken(): void {
			this.coachService.getSSOForTrainerizeForMember(this.profile.partyId)
			.then((value: AxiosResponse<EcCommon.ITrainerizeToken>) => {
				this.trainerizeToken = value.data;
				this.goToVLT();
			}, (error: AxiosError) => {
				this.$nextTick(() => {
					const modalId = this.getId(ProgramAlertConstant.programError);
					$(`#${modalId}`).modal('show');
				});
			});
		},
		getId(id: string): string {
			const componentId = (this.$el.parentElement as HTMLElement).id;
			let modalId = id;
			if (componentId.indexOf('_') !== -1) {
				const index = componentId.substr(componentId.indexOf('_') + 1);
				modalId += `_${index}`;
			}

			return modalId;
		},
		startProgram(): void {
			const userEnrolledPrograms = _.filter(this.userPrograms, (program) => {
				return moment().isBetween(program.startDate, program.endDate) || moment().isBefore(program.startDate);
			});

			if (!this.programSettings.sourceId) {
				this.$nextTick(() => {
					const modalId = this.getId(ProgramAlertConstant.programNotFound);
					$(`#${modalId}`).modal('show');
				});
				return;
			} else if (userEnrolledPrograms.length) {
				this.$nextTick(() => {
					const modalId = this.getId(ProgramAlertConstant.newProgramEnrollment);
					$(`#${modalId}`).modal('show');
				});
			} else {
				this.planService.startProgram(this.profile.partyId, this.programSettings.sourceId, this.programSettings.programType)
					.then((response: AxiosResponse<EcCommon.ITrainerizeToken>) => {
						EventHub.$emit(EventConstant.programChange, this.programSettings.sourceId, this.programSettings.programType);
						this.trainerizeToken = response.data;

						if (this.mobileUtils.isMobile) {
							this.goToVLT();
						} else {
							this.$nextTick(() => {
								const modalId = this.getId(ProgramAlertConstant.LifeTimeTrainingApp);
								$(`#${modalId}`).modal('show');
							});
						}
					}, (error: AxiosError) => {
						if (error && error.response && error.response.data && error.response.data.errorType) {
							if (error.response.data.errorType === 'InvalidTrainerizeProgram') {
								this.$nextTick(() => {
									const modalId = this.getId(ProgramAlertConstant.programNotFound);
									$(`#${modalId}`).modal('show');
								});
							} else {
								this.$nextTick(() => {
									const modalId = this.getId(ProgramAlertConstant.programError);
									$(`#${modalId}`).modal('show');
								});
							}
						}
					});
			}
		},
		switchProgram(): void {
			this.planService.postSwitchProgram(this.profile.partyId, this.programSettings.sourceId, this.programSettings.programType)
				.then((response: AxiosResponse<EcCommon.ITrainerizeToken>) => {
					EventHub.$emit(EventConstant.programChange, this.programSettings.sourceId, this.programSettings.programType);
					this.trainerizeToken = response.data;

					if (this.mobileUtils.isMobile) {
						this.goToVLT();
					} else {
						this.$nextTick(() => {
							const modalId = this.getId(ProgramAlertConstant.LifeTimeTrainingApp);
							$(`#${modalId}`).modal('show');
						});
					}
				}, (error: AxiosError) => {
					if (error && error.response && error.response.data && error.response.data.errorType) {
						if (error.response.data.errorType === 'InvalidTrainerizeProgram') {
							this.$nextTick(() => {
								const modalId = this.getId(ProgramAlertConstant.programNotFound);
								$(`#${modalId}`).modal('show');
							});
						} else {
							this.$nextTick(() => {
								const modalId = this.getId(ProgramAlertConstant.programError);
								$(`#${modalId}`).modal('show');
							});
						}
					}
				}).finally(() => {
					const modalId = this.getId(ProgramAlertConstant.newProgramEnrollment);
					$(`#${modalId}`).modal('hide');
				});
		},
		...mapActions(ProfileModuleConstant.name, {synchronizeProfileStore: ProfileModuleConstant.action.synchronize}),
		...mapActions(UrlModuleConstant.name, {synchronizeUrlStore: UrlModuleConstant.action.synchronize}),
	},
	created(): void {
		if (window.__PRERENDER_INJECTED || RegularExpressionConstant.authorRegex.test(window.location.href)) {
			this.initializing = false;
			return;
		}

		EventHub.$on(EventConstant.programChange, (sourceId: string, programType: string) => {
			this.isUserEnrolledInProgram = (this.programSettings.sourceId === sourceId && this.programSettings.programType === programType);
		});

		this.mobileUtils = MobileUtils();

		Promise.all([this.synchronizeProfileStore(), this.synchronizeUrlStore()]).then(() => {
			if (this.getIsProfileValid) {
				const rootElement = this.$el.parentElement as HTMLElement;
				const uuid = $(rootElement).data('uuid');

				if (uuid && $('#' + uuid).length > 0) {
					this.programSettings = JSON.parse($('#' + uuid).html());
				}
				this.getProgramListForMember();
			}
		}).finally(() => {
			this.initializing = false;
		});
	},
	mounted(): void {
		this.$nextTick(() => {
			const modalIds = [ProgramAlertConstant.programNotFound, ProgramAlertConstant.newProgramEnrollment, ProgramAlertConstant.programError, ProgramAlertConstant.LifeTimeTrainingApp];

			for (const modalId of modalIds) {
				const programModals = $(`div[id^="${modalId}"]`);
				for (let index = 0; index < programModals.length ; index++) {
					if (programModals.length > 1) {
						$(programModals[index]).attr('id', `${modalId}_${index + 1}`);
						$(programModals[index]).attr('aria-labelledby', `${modalId}Label_${index + 1}`);
						$(programModals[index]).find('h5').attr('id', `${modalId}Label_${index + 1}`);
					}
				}
			}
		});
	},
});
